import { Component, OnInit } from '@angular/core';
import {Title } from "@angular/platform-browser";

@Component({
  selector: 'app-dms',
  templateUrl: './dms.component.html',
  styleUrls: ['./dms.component.css']
})
export class DmsComponent implements OnInit {

  constructor(
    private titleService: Title,
  ) { }

  ngOnInit(): void {
    this.titleService.setTitle("DMS - SFI Compliance, Inc");
  }

}
